import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SimpleGlobal } from 'ng2-simple-global';
import { validateNumericCharacters } from '../../common/validators/numeric-validator.directive';
import { validateLength } from '../../common/validators/length-validator.directive';
import { IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { Router, ActivatedRoute } from '@angular/router';
import { OcrService } from '../../core/services/ocr.service';

@Component({
  selector: 'app-ocr-address',
  templateUrl: './ocr-address.component.html',
  styleUrls: ['./ocr-address.component.css']
})
export class OcrAddressComponent implements OnInit {

  addressForm: FormGroup;

  mySettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'multiselect-items btn btn-default',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: false,
    maxHeight: '300px',
    selectionLimit: 1,
    autoUnselect: true,
    closeOnSelect: true
  };

  lotId: number;
  employeeId: any;

  constructor(public global: SimpleGlobal,
    private fb: FormBuilder,
    private router: Router,
    private ocrService: OcrService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.lotId = +(this.activatedRoute.snapshot.params.id);

    this.activatedRoute.queryParams.subscribe(params => {
      this.employeeId = +params['employeeId'];
    });

    this.initForm();
  }

  initForm() {

    this.addressForm = this.fb.group({
      current_address_line1: [''],
      current_address_line2: [''],
      current_address_line3: [''],
      current_address_line4: [''],
      current_state_id: ['', Validators.required],
      current_state_name: ['', Validators.required],
      current_district_id: ['', Validators.required],
      current_district_name: ['', Validators.required],
      current_pincode: ['', [validateNumericCharacters(''), validateLength('6')]],
      current_landmark: [''],
      current_reference_name: [''],
      current_reference_number: ['', [validateNumericCharacters(''), validateLength('10')]],
      current_reference_relation: [''],
      current_duration_of_stay: [''],
      current_police_station: [''],
      current_post_office: [''],
      permanent_address_line1: [''],
      permanent_address_line2: [''],
      permanent_address_line3: [''],
      permanent_address_line4: [''],
      permanent_state_id: ['', Validators.required],
      permanent_state_name: ['', Validators.required],
      permanent_district_id: ['', Validators.required],
      permanent_district_name: ['', Validators.required],
      permanent_pincode: ['', [validateNumericCharacters(''), validateLength('6')]],
      permanent_landmark: [''],
      permanent_reference_name: [''],
      permanent_reference_number: ['', [validateNumericCharacters(''), validateLength('10')]],
      permanent_reference_relation: [''],
      permanent_duration_of_stay: [''],
      permanent_police_station: [''],
      permanent_post_office: [''],
    });

  }

  // Set the value of the invite control state_id
  OnStateSelect(event, type) {

    let state = type + '_state_id';
    let district = type + '_district_id';


    this.addressForm.get(state).setValue(event[0]);

    // Setting the default value on any change is selection of state.
    this.addressForm.get(district).setValue('');
  }

  // Set the value of the invite control district_id
  OnDistrictSelect(event, type) {
    let district = type + '_district_id';


    this.addressForm.get(district).setValue(event[0]);
  }

  submitForm() {

    const data = {
      ...this.addressForm.value,
      employeeId: this.employeeId
    };



    this.ocrService.submitAddress(data).subscribe((response) => {
      const url = this.activatedRoute.snapshot.url;
      url.splice(-1, 1);
      this.router.navigateByUrl(url.join('/') + '/success');
     });


  }



}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-address/ocr-address.component.ts